<template>
    <!-- Common Banner Area -->
    <FlightPassengersBanner />

    <!-- Booking Submission Areas -->
    <FlightPassengers />

</template>
  
<script>
// @ is an alias to /src
import FlightPassengersBanner from '@/components/flight-passengers/FlightPassengersBanner.vue'
import FlightPassengers from '@/components/flight-passengers/FlightPassengers.vue'
export default {
    name: 'FlightPassengersView',
    components: {
        FlightPassengersBanner, FlightPassengers
    }
}
</script>